import { styled } from "styled-components";

import {
  Card,
  CardSkeleton,
  ParagraphSkeleton,
  SectionLabel,
  Skeleton,
  Spacer,
  Text,
} from "@vericus/cadmus-ui";

import { RequirementsFragment, ResourceFragment } from "@/generated/graphql";
import { TaskEditorContentReadOnly } from "@/ui/task/editor";
import { RequirementView } from "@/ui/task/requirements";
import { ResourceListReadOnly } from "@/ui/task/resources";

interface Props {
  /** The title for the template or past assessment */
  title: string;
  /** Requirements for the assessment */
  requirements: RequirementsFragment;
  /** Editor content */
  content: string;
  isHtmlContent?: boolean;
  resources: ResourceFragment[];
}

export function TemplatePreview(props: Props) {
  
  return (
    <PaddedCard>
      <Container>
        <AssessmentTitleText kind="displayTwo">{props.title}</AssessmentTitleText>
        <Spacer spacing={48} />
        <RequirementView
          requirements={props.requirements}
          showHidden
          shouldShowEmptyState
        />
      </Container>
      <Spacer spacing={48} />

      <TaskLabel title="Task" />
      <TaskEditorContentReadOnly content={props.content} isHtmlContent />
      <Spacer spacing={48} />
      <Container>
        <ResourceListReadOnly resources={props.resources} />
      </Container>
    </PaddedCard>
  );
}

export const DoubleColumnPreviewSkeleton = () => {
  return (
    <PaddedCard>
      <Container>
        <Skeleton width={25} />
        <Spacer spacing={60} />
        <ParagraphSkeleton />

        <Skeleton width={60} />
      </Container>

      <Spacer spacing={48} />
      <Container>
        <Skeleton width={80} />
        <CardSkeleton heightPx={184} />
        <CardSkeleton heightPx={184} />
        <Skeleton width={80} />
        <CardSkeleton heightPx={184} />
        <CardSkeleton heightPx={184} />
      </Container>
    </PaddedCard>
  );
};

const AssessmentTitleText = styled(Text)`
  margin-bottom: 54px;
  padding: 0;
`;

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
  padding-left: 45px;
  padding-right: 45px;
  margin-left: auto;
  margin-right: auto;
`;

const TaskLabel = styled(SectionLabel)`
  padding: 0 45px 27px 45px;
  max-width: 800px;
  box-sizing: border-box;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: -63px;
`;

const PaddedCard = styled(Card)`
  box-sizing: border-box;
  padding: 64px 70px;
  height: 100%;
  max-height: 100%;
  width: 100%;
`;
